import { createContext, useContext } from 'react';
const initialMultiStepState = {
    currentStep: null,
    currentIndex: 0,
    stepDirection: 1,
    steps: [],
    handleNext: () => null,
    handleBack: () => null,
    handleComplete: () => null,
    handleNavigateTo: () => null,
    insertStep: () => null,
    insertStepAndNavigate: () => null,
    experimentVariationsMeta: {},
    setCurrentIndex: () => null,
    onBeforeNext: null,
    registerOnBeforeNext: () => null,
};
export const MultiStepContext = createContext(initialMultiStepState);
MultiStepContext.displayName = 'MultiStepContext';
export function useMultiStep() {
    const ctx = useContext(MultiStepContext);
    if (!ctx) {
        throw new Error('useMultiStep must be used within MultiStepContext');
    }
    return ctx;
}
//# sourceMappingURL=MultiStepProviderShared.js.map